export default "__VITE_ASSET__DMjQQG3Y__"